module.exports = __webpack_public_path__ + "img/cashier_pocket_edition_poster.d85af6bc.jpg";